import classNames from "classnames";

const CasesTableCell = ({ cell, isCellExpanded, editing }: any) => {
  return (
    <td {...cell.getCellProps()}>
      <div
        className={classNames("ViewerListTable__cell", {
          expanded__cell: isCellExpanded,
        })}
        style={{ minWidth: cell.column.minWidth }}
      >
        {editing ? (
          <input value={cell.value} />
        ) : (
          cell.render("Cell", { isCellExpanded: isCellExpanded })
        )}
      </div>
    </td>
  );
};

export default CasesTableCell;
